import React from "react";

import * as styles from "./SeparatorBar.module.css";

export const SeparatorBar = () => <hr className={styles.separatorLine} />;
